export default __webpack_public_path__ + "static/media/btn-instagram.3e4ebf66.png";